module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-curcuma.0d51d6e9.jpg";